// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__kkd5l","buttons":"Footer_buttons__1ZzmN"};